import type { InputHTMLAttributes } from "react";

const NeoInput = (props: InputHTMLAttributes<HTMLInputElement>) => {
  return (
    <input
      type="text"
      className="search__input"
      placeholder="Search for recipes, ingredients, or products..."
      {...props}
    />
  );
};

export default NeoInput;
